import { TabbedGroup } from "../../../components/TabbedGroup";
import { AdminPermissions as AP } from "../../../lib/data";
import Proofs from "../Proofs";
import FraudReview from "../FraudReview";

export default function Review() {
  return (
    <TabbedGroup
      tabs={[
        { value: "proofs", label: "Proof Submissions", permission: AP.MANAGE_MISSIONS, element: <Proofs /> },
        { value: "fraud", label: "Fraud Review", permission: AP.MANAGE_PROOFS, element: <FraudReview /> },
      ]}
    />
  );
}
